import React, { createContext, useContext, useState, useEffect } from 'react';

const CART_STORAGE_KEY = 'loucas_cart';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem(CART_STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const getCorKey = (item) => (item.corSelecionada?.descricao_cor ?? '').trim();

  const addItem = (produto, quantidade = 1, opcoes = {}) => {
    const corSelecionada = opcoes.corSelecionada || null;
    const newCorKey = (corSelecionada?.descricao_cor ?? '').trim();
    setItems((prev) => {
      const existing = prev.find(
        (i) => i.produto.id === produto.id && getCorKey(i) === newCorKey
      );
      if (existing) {
        return prev.map((i) =>
          i.produto.id === produto.id && getCorKey(i) === newCorKey
            ? { ...i, quantidade: Math.min((i.quantidade || 0) + quantidade, produto.estoque_quantidade ?? 999) }
            : i
        );
      }
      return [...prev, { produto, quantidade, corSelecionada: corSelecionada || undefined }];
    });
  };

  const removeItem = (produtoId, corKey = '') => {
    const key = (corKey ?? '').trim();
    setItems((prev) =>
      prev.filter(
        (i) => !(i.produto.id === produtoId && getCorKey(i) === key)
      )
    );
  };

  const updateQuantity = (produtoId, quantidade, corKey = '') => {
    if (quantidade <= 0) {
      removeItem(produtoId, corKey);
      return;
    }
    const key = (corKey ?? '').trim();
    setItems((prev) =>
      prev.map((i) =>
        i.produto.id === produtoId && getCorKey(i) === key ? { ...i, quantidade } : i
      )
    );
  };

  const clearCart = () => setItems([]);

  const totalItems = items.reduce((acc, i) => acc + (i.quantidade || 0), 0);
  const totalPrice = items.reduce(
    (acc, i) => acc + parseFloat(i.produto.preco || 0) * (i.quantidade || 0),
    0
  );

  return (
    <CartContext.Provider
      value={{
        items,
        addItem,
        removeItem,
        updateQuantity,
        clearCart,
        totalItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
}
